// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/ProductCardElastic/ProductCardElastic.module.css
// module id = 1240
// module chunks = 0